import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'
import ManageService from '../ManageService/ManageService.vue'
import ManageMachineDowntime from '../ManageMachineDowntime/ManageMachineDowntime.vue'
import ManageServiceCost from '../ManageServiceCost/ManageServiceCost.vue'
import CloseServiceOrder from '../CloseServiceOrder/CloseServiceOrder.vue'
import TemplateSelect from '../ChecklistTemplate/templateSelect/templateSelect.vue'
import InstitutionInactive from '../../../../Institutions/components/institutionInactive/institutionInactive.vue'
import DepartmentInactive from '../../../../Department/deparmentInactive/departmentInactive.vue'
import moment from 'moment'

export default {
  props: {
    serviceOrderId: String,
  },

  components: {
    ManageService,
    ManageMachineDowntime,
    ManageServiceCost,
    CloseServiceOrder,
    TemplateSelect,
    InstitutionInactive,
    DepartmentInactive,
  },

  async created() {
    window.scrollTo(0, 0)

    const called = JSON.parse(sessionStorage.getItem('called'))
    this.currentUser = JSON.parse(localStorage.getItem('user'))

    this.institution = JSON.parse(localStorage.getItem('institution'))

    this.institutionId = this.$route.params.institutionIdProp
    this.institutionInactive = institution.status == 1
    await this.getInstitutions()
    await this.getUnidades()
    await this.getDepartments()
    // getCostCenters() será chamado quando uma unidade for selecionada
    await this.getSuppliers()
    await this.getEquipments()
    await this.getUsers()

    if (this.serviceOrderId) {
      await this.getServiceOrder(this.serviceOrderId)
    }

    if (called) {
      this.currentServiceOrder.category = this.categories[called.category]
      this.equipmentVisible = called.category == 0 ? true : false
      this.currentCalled = called
      this.unidadeId = called.unidadeId
      this.currentServiceOrder.name = `Chamado Nº ${called.number}`
      this.currentServiceOrder.requester = called.userRequester.name
      this.requestDateTime = called.createdAt
      this.currentServiceOrder.request = called.request
      this.equipmentId = called.equipmentId
      this.departmentId = called.departmentId
      if (called.equipment) {
        this.querySelectionsEquipment(called.equipment.identification)
      }
    }
    this.disabled =
      this.institution.userType == 4 ||
      this.institution.userType == 5 ||
      this.currentServiceOrder.status == 1
  },

  data: () => ({
    institution: {},
    expandedServices: [],
    expandedDowntimes: [],
    expandedServicesCosts: [],
    searchEquipment: null,
    searchEquipmentPropertyCode: null,
    step: 0,
    selectedRequestTab: 0,
    selectedAttendTab: 0,
    errorMessage: '',
    disabled: false,
    calledRemove: false,
    loading: false,
    supplierLoading: false,
    institutionLoading: false,
    unidadeLoading: false,
    equipmentLoading: false,
    servicesLoading: false,
    machineDowntimesLoading: false,
    serviceOrderCostsLoading: false,
    checklistTemplateLoading: false,
    printChecklistLoading: false,
    departmentLoading: false,
    costCenterLoading: false,
    firstValid: true,
    alterDialog: false,
    supplierDialog: false,
    serviceDialog: false,
    downtimeDialog: false,
    costDialog: false,
    editServiceDialog: false,
    editDowntimeDialog: false,
    editCostDialog: false,
    removeDialog: false,
    closeServiceOrderDialog: false,
    signatureErrorDialog: false,
    activeOstemplateDialog: false,
    inactiveOsTemplateDialog: false,
    templateSelectDialog: false,
    notCalibrationDialog: false,
    deleteDialog: false,
    dialogKey: false,
    newChecklist: false,
    changedData: false,
    deleteService: false,
    deleteDowntime: false,
    deleteCost: false,
    isEditing: false,
    error: false,
    serviceOrderClosing: false,
    institutionInactive: false,
    departmentInactive: false,
    equipmentVisible: true,
    newService: false,
    newDowntime: false,
    showSuplier: false,
    withoutValues: false,
    requestDateTimeError: false,
    attendDateTimeError: false,
    requestDateTime: null,
    attendDateTime: null,
    currentCalled: null,
    tab: null,
    users: [],
    checklistId: null,
    institutionId: null,
    institutions: [],
    unidadeId: null,
    unidades: [],
    costCenterId: null,
    costCenters: [],
    departmentId: null,
    departments: [],
    supplierId: null,
    suppliers: [],
    equipmentId: null,
    equipments: [],
    equipmentsFiltered: [],
    equipmentSelected: {},
    serviceId: null,
    services: [],
    serviceOrderCostsId: null,
    serviceOrderCosts: [],
    machineDowntimeId: null,
    machineDowntimes: [],
    departmentName: null,
    costCenterName: null,
    textRemove: null,
    currentService: {},
    currentServiceCost: {},
    currentMachineDowntime: {},
    currentUser: {},
    checklistTemplates: [],
    checklistTemplateId: null,
    templateItems: [],
    uploadDocuments: [],
    calibrations: [],
    serviceOrderInternalTypes: [
      'Treinamento',
      'Segurança elétrica',
      'Preventiva',
      'Instalação',
      'Rotina de Inspeção',
      'Corretiva',
      'Calibração',
      'Validação/Qualificação',
      'Serviço Administrativo',
      'Empréstimo',
    ],
    causeDefects: [
      'Não aplicável',
      'Falha intrínseca',
      'Falha infraestrutura',
      'Erro operacional',
      'Dano acidental',
      'Abuso na utilização',
    ],
    statusStep: [
      'Manutenção terceirizada in loco',
      'Manutenção terceirizada externa',
      'Manutenção interna',
      'Aguardando peça',
      'Aguardando orçamento',
      'Aguardando avaliação externa',
      'Aguardando aprovação de orçamento',
      'Aguardando liberação do setor',
      'Equipamento não encontrado',
      'Aguardando Solicitação/Ordem de Compra',
    ],
    costTypes: ['Custo material', 'Custo serviços'],
    categories: ['Equipamento', 'Setor'],
    currentServiceOrder: {
      id: 0,
      name: '',
      serviceOrderType: null,
      number: '',
      requester: '',
      requestDateTime: null,
      attendDateTime: null,
      request: '',
      causeDefect: null,
      isExternal: false,
      category: 'Equipamento',
    },
    nameRules: [
      (v) => !!v || 'Nome da O.S. requerido',
      (v) =>
        v.length <= 128 || 'Nome da O.S. deve ter no máximo 128 caracteres',
    ],
    institutionRules: [(v) => !!v || 'Instituição é requerida'],
    unidadeRules: [(v) => !!v || 'Unidade é requerida'],
    typeOsRules: [(v) => (v != -1 && !!v) || 'Tipo da O.S. é requerida'],
    requestDateTimeRules: [(v) => !!v || 'Data da solicitação é requerida'],
    requesterRules: [
      (v) => !!v || 'Solicitante é requerido',
      (v) => v.length <= 128 || 'Solicitante deve ter no máximo 128 caracteres',
    ],
    requestRules: [
      (v) =>
        v == null ||
        v.length <= 200 ||
        'Solicitação/Reclamação deve ter no máximo 128 caracteres',
    ],
    apiService: new ApiService(),
    headersServices: [
      {
        text: 'Data e hora início',
        align: 'center',

        value: 'dateTimeStartStep',
      },
      {
        text: 'Data e hora fim',
        align: 'center',

        value: 'dateTimeEndStep',
      },
      {
        text: 'Estado O.S.',
        align: 'center',

        value: 'statusStepServiceOrder',
      },
      {
        text: 'Tempo',
        align: 'center',

        value: 'timeSpent',
        sortable: false,
      },
      {
        text: 'Responsável',

        align: 'center',
        value: 'user',
        sortable: false,
      },
      {
        text: 'Ações',

        value: 'actions',
        align: 'center',
        sortable: false,
      },
    ],
    headersServicesMobile: [
      {
        text: 'Estado O.S.',
        align: 'center',

        value: 'status',
      },
      {
        text: 'Ações',

        value: 'actions',
        align: 'center',
        sortable: false,
      },
    ],
    headersMachineDowntime: [
      {
        text: 'Data hora parada',
        align: 'center',

        value: 'stoppedDateTime',
      },
      {
        text: 'Data hora retorno',
        align: 'center',

        value: 'returnDateTime',
      },
      {
        text: 'Ações',

        value: 'actions',
        align: 'center',
        sortable: false,
      },
    ],
    headersMachineDowntimeMobile: [
      {
        text: 'Data hora parada',
        align: 'center',

        value: 'stoppedDateTime',
      },
      {
        text: 'Data hora retorno',
        align: 'center',

        value: 'returnDateTime',
      },
    ],
    headersServiceOrderCost: [
      {
        text: 'Nº Nota',
        align: 'center',

        value: 'invoice',
      },
      {
        text: 'Tipo custo',
        align: 'center',

        value: 'costType',
      },
      {
        text: 'Custo',
        align: 'center',

        value: 'cost',
      },
      {
        text: 'Fornecedor',
        align: 'center',

        value: 'supplier',
        sortable: false,
      },
      {
        text: 'Descrição',

        align: 'center',
        value: 'description',
        sortable: false,
      },
      {
        text: 'Ações',

        value: 'actions',
        align: 'center',
        sortable: false,
      },
    ],
    headersServiceOrderCostMobile: [
      {
        text: 'Custo',
        align: 'center',

        value: 'cost',
      },
      {
        text: 'Fornecedor',
        align: 'center',

        value: 'supplier',
      },
    ],
  }),

  computed: {
    buttonText() {
      return this.isEditing ? 'Atualizar' : 'Adicionar'
    },
  },

  methods: {
    changeRequest(event) {
      if (
        this.currentServiceOrder.request == '' ||
        this.currentServiceOrder.request == null
      ) {
        switch (event) {
          case 'Preventiva':
            this.currentServiceOrder.request =
              'Execução da manutenção preventiva.'
            break
          case 'Calibração':
            this.currentServiceOrder.request = 'Execução de calibração.'
            break
          case 'Segurança elétrica':
            this.currentServiceOrder.request =
              'Execução do teste de segurança elétrica.'
            break
          case 'Treinamento':
            this.currentServiceOrder.request = 'Execução de treinamento.'
            break
          case 'Validação/Qualificação':
            this.currentServiceOrder.request =
              'Execução de validação/qualificação. '
            break
        }
      }
    },
    close() {
      sessionStorage.clear()
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$router.go(-1)
      }
    },

    closeDialog() {
      if (this.supplierDialog) {
        this.supplierDialog = false
        this.getSuppliers()
      } else if (this.serviceDialog) {
        this.serviceDialog = false
        this.getServices()
      } else if (this.downtimeDialog) {
        this.downtimeDialog = false
        this.getMachineDowntimes()
      } else if (this.costDialog) {
        this.costDialog = false
        this.getServiceOrderCosts()
      } else if (this.editServiceDialog) {
        this.editServiceDialog = false
        this.getServices()
      } else if (this.editDowntimeDialog) {
        this.editDowntimeDialog = false
        this.getMachineDowntimes()
      } else if (this.editCostDialog) {
        this.editCostDialog = false
        this.getServiceOrderCosts()
      } else if (this.closeServiceOrderDialog) {
        this.closeServiceOrderDialog = false
      } else if (this.templateSelectDialog) {
        this.templateSelectDialog = false
        this.$router.go(-1)
      } else {
        this.changedData = false
        this.close()
      }
    },

    addSupplier() {
      this.dialogKey = !this.dialogKey
      this.supplierDialog = true
    },

    addService() {
      if (!this.isEditing && this.currentServiceOrder.id == 0) {
        this.newService = true
        this.submit()
      }

      if (this.$refs.firstForm.validate()) {
        this.dialogKey = !this.dialogKey
        this.serviceDialog = true
      }
    },

    editService(service) {
      this.currentService = service
      this.editServiceDialog = true
      this.dialogKey = !this.dialogKey
    },

    removeService(service) {
      this.currentService = service
      this.textRemove = 'o serviço'
      this.removeDialog = true
      this.deleteService = true
    },

    addDowntime() {
      if (!this.isEditing && this.currentServiceOrder.id == 0) {
        this.newDowntime = true
        this.submit()
      }

      if (this.$refs.firstForm.validate()) {
        this.dialogKey = !this.dialogKey
        this.downtimeDialog = true
      }
    },

    editMachineDowntime(downtime) {
      this.currentMachineDowntime = downtime
      this.editDowntimeDialog = true
      this.dialogKey = !this.dialogKey
    },

    removeMachineDowntime(downtime) {
      this.currentMachineDowntime = downtime
      this.textRemove = 'a hora parada'
      this.removeDialog = true
      this.deleteDowntime = true
    },

    addCost() {
      this.dialogKey = !this.dialogKey
      this.costDialog = true
    },

    editCost(cost) {
      this.currentServiceCost = cost
      this.editCostDialog = true
      this.dialogKey = !this.dialogKey
    },

    removeCost(cost) {
      this.currentServiceCost = cost
      this.textRemove = 'o custo'
      this.removeDialog = true
      this.deleteCost = true
    },

    openChecklist() {
      if (
        this.currentServiceOrder.status == 0 &&
        this.currentServiceOrder.checklistTemplateId != null &&
        this.currentServiceOrder.checklists.length > 0
      ) {
        this.activeOstemplateDialog = true
      } else if (
        this.currentServiceOrder.status == 1 &&
        this.currentServiceOrder.checklistTemplateId != null &&
        this.currentServiceOrder.checklists.length > 0
      ) {
        this.inactiveOsTemplateDialog = true
      } else if (
        this.departmentInactive &&
        this.currentServiceOrder.checklistTemplateId != null &&
        this.currentServiceOrder.checklists.length > 0
      ) {
        this.inactiveOsTemplateDialog = true
      } else {
        this.openTemplateSelect()
      }
    },

    openTemplateSelect() {
      this.newChecklist = true
      this.activeOstemplateDialog = false
      this.templateSelectDialog = true
      this.dialogKey = !this.dialogKey
    },

    openEquipment() {
      if (this.equipmentId) {
        const route = this.$router.resolve({
          path: `/editEquipment/${this.equipmentId}`,
        })
        window.open(route.href, '_blank')
      }
    },

    viewChecklist() {
      const checklist = this.currentServiceOrder.checklists[0]
      const checklistServiceOrder = {
        ServiceOrderId: checklist.serviceOrderId,
        ChecklistId: checklist.id,
        isValidatorSigned: checklist.isValidatorSigned,
        EquipmentId: checklist.equipmentId,
      }
      sessionStorage.setItem('checklist', JSON.stringify(checklistServiceOrder))
      sessionStorage.setItem(
        'serviceOrder',
        JSON.stringify(this.currentServiceOrder)
      )
      this.$router.push('/formChecklist')
    },

    categorySelected() {
      this.equipmentVisible =
        this.categories.indexOf(this.currentServiceOrder.category) == 0
      if (!this.isEditing) {
        this.unidadeId = null
        this.departmentId = null
      }
      this.equipmentId = null
      this.equipmentSelected = {}
    },

    async generateChecklistPDF() {
      const checklist = this.currentServiceOrder.checklists[0]
      const route = this.$router.resolve({
        path: `/printChecklist/${checklist.id}`,
      })
      window.open(route.href, '_blank')
    },

    uploadDocument() {
      sessionStorage.clear()
      sessionStorage.setItem(
        'serviceOrder',
        JSON.stringify(this.currentServiceOrder)
      )
      this.$router.push({ path: '/bigData-uploadDocument' })
    },

    closingServiceOrder() {
      if (this.currentServiceOrder.status == 0) {
        this.serviceOrderClosing = true
        if (this.$refs.firstForm.validate() && this.attendDateTime) {
          this.submit()
        } else {
          this.$refs.firstForm.$el.scrollIntoView({ behavior: 'smooth' })
          this.attendDateTimeError = this.attendDateTime == null
        }
      } else {
        this.cancelClosing()
      }
    },

    async getUsers() {
      await this.apiService
        .get(`user/list/${this.institutionId}`)
        .then((response) => {
          this.users = response.content
        })
    },

    getUserName(userId) {
      const user = this.users.find((user) => user.id == userId)

      if (user) return user.name
    },

    getSupplierName(supplierId) {
      if (!supplierId) return 'Sem registro'

      return this.suppliers.find((supplier) => supplier.id == supplierId).name
    },

    checkStatusStep() {
      const statusStep = this.services.map(
        (service) => service.statusStepServiceOrder
      )
      this.currentServiceOrder.isEditing =
        statusStep.includes(0) ||
        statusStep.includes(1) ||
        statusStep.includes(5)
      this.showSuplier =
        statusStep.includes(0) ||
        statusStep.includes(1) ||
        statusStep.includes(5)
    },

    signServiceOrder() {
      if (this.currentUser.signatureImage) {
        this.currentServiceOrder.isExecutingSigned = true
        this.currentServiceOrder.executingUserId = this.currentUser.id
        this.submit()
      } else {
        this.signatureErrorDialog = true
      }
    },

    validateServiceOrder() {
      if (this.currentUser.signatureImage) {
        this.currentServiceOrder.isValidatorSigned = true
        this.currentServiceOrder.validatorUserId = this.currentUser.id
        this.submit()
      } else {
        this.signatureErrorDialog = true
      }
    },

    async getServiceOrder(serviceOrderId) {
      await this.apiService
        .get(
          `serviceOrder/getServiceOrder/${this.institutionId}/${serviceOrderId}`
        )
        .then((response) => {
          this.isEditing = true
          const serviceOrder = response.content
          this.currentServiceOrder = serviceOrder
          this.currentServiceOrder.number = String(
            response.content.number
          ).padStart(3, '0')
          this.equipmentId = serviceOrder.equipmentId
          this.unidadeId = serviceOrder.unidadeId
          this.costCenterId = this.currentServiceOrder.costCenterId
          this.currentServiceOrder.serviceOrderType =
            this.serviceOrderInternalTypes[serviceOrder.serviceOrderType]
          this.currentServiceOrder.causeDefect =
            this.causeDefects[serviceOrder.causeDefect]
          this.requestDateTime = serviceOrder.dateTimeRequest
          this.attendDateTime = serviceOrder.dateTimeAttend
          this.supplierId = serviceOrder.supplierId
          this.checklistTemplateId = serviceOrder.checklistTemplateId
          if (serviceOrder.name.includes('Chamado')) {
            this.getCalled()
          }
          if (serviceOrder.equipment && serviceOrder.equipment.alienated) {
            this.equipments.unshift(serviceOrder.equipment)
          }
          if (serviceOrder.checklistServiceOrders.length > 0) {
            this.checklistId =
              serviceOrder.checklistServiceOrders[0].checklistId
          }
          this.currentServiceOrder.request =
            serviceOrder.request != null ? serviceOrder.request : ''
          this.uploadDocuments = serviceOrder.uploadDocuments
          this.calibrations = serviceOrder.calibrations

          this.departmentInactive = serviceOrder.department.status == 1
          this.currentServiceOrder.category =
            this.categories[serviceOrder.category]
          if (serviceOrder.category === 'Setor') {
            this.departmentId = serviceOrder.departmentId
            this.categorySelected()
          } else {
            this.querySelectionsEquipment(serviceOrder.equipment.identification)
          }
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          if (err.status === 404) {
            this.$router.push('/serviceOrders')
          }

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      await this.getServices()
      await this.getServiceOrderCosts()
      await this.getMachineDowntimes()
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
        this.institutionLoading = false
      })
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getCostCenters() {
      this.costCenterLoading = true

      if (!this.unidadeId || this.unidadeId === 0) {
        this.costCenters = []
        this.costCenterLoading = false
        return
      }

      await this.apiService
        .get(`costCenter/listActiveByUnidade/${this.institutionId}/${this.unidadeId}`)
        .then((response) => {
          this.costCenters = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.costCenterLoading = false
    },

    async getDepartments() {
      this.departmentLoading = true

      await this.apiService
        .get(`department/list/${this.institutionId}`)
        .then((response) => {
          this.departments = response.content
          this.departmentLoading = false
        })
    },

    async getSuppliers() {
      this.supplierLoading = true

      await this.apiService
        .get(`supplier/list/${this.institutionId}`)
        .then((response) => {
          this.suppliers = response.content
          this.supplierLoading = false
        })
    },

    async getEquipments() {
      this.equipmentLoading = true

      await this.apiService
        .get(`equipment/list/${this.institutionId}`)
        .then((response) => {
          this.equipments = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.equipmentLoading = false
    },

    async getServices() {
      this.servicesLoading = true
      await this.apiService
        .get(`service/list/${this.currentServiceOrder.id}`)
        .then((response) => {
          this.services = response.content
          this.checkStatusStep()
          this.servicesLoading = false
        })
    },

    async getServiceOrderCosts() {
      this.servicesLoading = true
      await this.apiService
        .get(`serviceOrderCost/list/${this.currentServiceOrder.id}`)
        .then((response) => {
          this.serviceOrderCosts = response.content
          this.servicesLoading = false
        })
    },

    async getMachineDowntimes() {
      this.machineDowntimesLoading = true
      await this.apiService
        .get(`machineDowntime/list/${this.currentServiceOrder.id}`)
        .then((response) => {
          this.machineDowntimes = response.content
          this.machineDowntimesLoading = false
        })
    },

    async getChecklistTemplate() {
      if (this.equipmentSelected == null) return

      this.checklistTemplateLoading = true

      const templateModel = {
        StandardEquipmentId: this.equipmentSelected.standardEquipmentId,
        InstitutionId: this.institutionId,
      }

      await this.apiService
        .post(`checklistTemplate/listByEquipment`, templateModel)
        .then((response) => {
          this.checklistTemplates = response.content
          this.checklistTemplateLoading = false
        })
    },

    async getTemplateItems() {
      const checklistTemplate = this.checklistTemplates.filter(
        (x) => x.id == this.checklistTemplateId
      )[0].checklistTemplate
      this.templateItems = checklistTemplate.templateItems
    },

    async getCalled() {
      await this.apiService
        .get(`called/getCalled/${this.currentServiceOrder.id}`)
        .then((response) => {
          if (response.content) {
            this.currentCalled = response.content
          } else {
            this.calledRemove = true
          }
        })
    },

    async openCalled() {
      await this.getCalled()
      let routeData = this.$router.resolve({
        path: `/editCalled/${this.currentCalled.id}`,
      })
      window.open(routeData.href, '_blank')
    },

    openCalibration() {
      sessionStorage.clear()
      sessionStorage.setItem(
        'serviceOrder',
        JSON.stringify(this.currentServiceOrder)
      )
      this.$router.push({ path: '/bigData-formCalibration' })
    },

    async openCertified() {
      if (this.calibrations.length > 0) {
        const calibration = this.calibrations[0]
        const route = this.$router.resolve({
          path: `/printCalibrationCertified/${this.institutionId}/${calibration.id}`,
        })
        window.open(route.href, '_blank')
      } else {
        this.notCalibrationDialog = true
        setTimeout(() => {
          this.notCalibrationDialog = false
        }, 3000)
      }
    },

    validateDates() {
      const requestDate = this.requestDateTime
      const attendDate = this.attendDateTime

      let valid = true

      if (
        !!requestDate &&
        !!attendDate &&
        moment(requestDate).isAfter(moment(attendDate))
      ) {
        this.$toast.warning(
          'A data de atendimento não pode ser antes da data de solicitação'
        )
        valid = false
      }

      return valid
    },

    async submit() {
      this.loading = true
      if (this.$refs.firstForm.validate() && this.requestDateTime) {
        if (this.validateDates()) {
          this.changeRequest(this.currentServiceOrder.serviceOrderType)
          const serviceOrder = {
            Id: this.currentServiceOrder.id,
            Name: this.currentServiceOrder.name,
            InstitutionId: this.institutionId,
            UnidadeId: this.unidadeId,
            DepartmentId: this.departmentId,
            CostCenterId: this.costCenterId,
            isExternal: this.currentServiceOrder.isExternal,
            ServiceOrderType: this.serviceOrderInternalTypes.indexOf(
              this.currentServiceOrder.serviceOrderType
            ),
            Requester: this.currentServiceOrder.requester,
            DateTimeRequest: Utils.nowDatetimeFormat(this.requestDateTime),
            DateTimeAttend:
              this.attendDateTime != null
                ? Utils.nowDatetimeFormat(this.attendDateTime)
                : null,
            Request: this.currentServiceOrder.request,
            EquipmentId: this.equipmentId,
            CauseDefect: this.currentServiceOrder.causeDefect
              ? this.causeDefects.indexOf(this.currentServiceOrder.causeDefect)
              : null,
            SupplierId: this.supplierId,
            ChecklistTemplateId: this.checklistTemplateId,
            isExecutingSigned: this.currentServiceOrder.isExecutingSigned,
            ExecutingUserId: this.currentServiceOrder.executingUserId,
            isValidatorSigned: this.currentServiceOrder.isValidatorSigned,
            ValidatorUserId: this.currentServiceOrder.validatorUserId,
            Category: this.categories.indexOf(
              this.currentServiceOrder.category
            ),
            CloseServiceOrderDateTime:
              this.currentServiceOrder.closeServiceOrderDateTime,
            EmailForEvaluation: this.currentServiceOrder.emailForEvaluation,
          }

          let url = 'serviceOrder/add'

          if (this.isEditing || serviceOrder.Id) {
            url = 'serviceOrder/edit'
          }

          await this.apiService
            .post(url, serviceOrder)
            .then((response) => {
              if (this.newService || this.newDowntime) {
                this.currentServiceOrder = response.content
                this.currentServiceOrder.category =
                  this.categories[response.content.category]
                this.currentServiceOrder.serviceOrderType =
                  this.serviceOrderInternalTypes[
                    response.content.serviceOrderType
                  ]
                this.newService = false
                this.newDowntime = false
              } else if (this.serviceOrderClosing) {
                this.currentServiceOrder.supplierId =
                  response.content.supplierId
                this.currentServiceOrder.emailForEvaluation =
                  this.currentCalled != null
                    ? this.currentCalled.userRequester.email
                    : null
                this.closeServiceOrderDialog = true
                this.serviceOrderClosing = false
              } else {
                this.changedData = false
                this.close()
              }

              if (
                this.currentServiceOrder.serviceOrderType == 'Preventiva' &&
                this.templateItems.length > 0
              ) {
                const checklistServiceOrder = {
                  ServiceOrderId: response.content.id,
                  TemplateItems: this.templateItems,
                }

                this.apiService
                  .post('checklistServiceOrder/add', checklistServiceOrder)
                  .then((response) => {})
              }

              this.saveCalled(response.content.id)
            })
            .catch((err) => {
              window.scrollTo(0, 0)
              this.errorMessage = err.message
              this.error = true

              setTimeout(() => {
                this.error = false
              }, 4000)
            })
        }
      } else {
        this.$refs.firstForm.$el.scrollIntoView({ behavior: 'smooth' })
        this.requestDateTimeError = this.requestDateTime == null
      }

      this.loading = false
      this.changedData = false
    },

    async saveCalled(serviceOrderId) {
      if (this.currentCalled != null) {
        this.currentCalled.serviceOrderId = serviceOrderId
        this.currentCalled.calledStatus = 1
        this.currentCalled.equipmentId = this.equipmentId

        await this.apiService
          .post('called/edit', this.currentCalled)
          .then((response) => {
            if (!this.isEditing) {
              this.sendMailOpenServiceOrder()
            }
          })
      }
    },

    async sendMailOpenServiceOrder() {
      if (this.currentCalled != null) {
        await this.apiService
          .post('called/sendMailServiceOrder', this.currentCalled)
          .then((response = {}))
      }
    },

    async deleteSelection() {
      this.loading = true
      let url = ''
      let data = {}

      if (this.deleteService) {
        url = 'service/delete'
        data = this.currentService
      }

      if (this.deleteDowntime) {
        url = 'machineDowntime/delete'
        data = this.currentMachineDowntime
      }

      if (this.deleteCost) {
        url = 'serviceOrderCost/delete'
        data = this.currentServiceCost
      }

      await this.apiService
        .post(url, data)
        .then(() => {
          this.deleteService = false
          this.deleteDowntime = false
          this.deleteCost = false
          this.getServices()
          this.getServiceOrderCosts()
          this.getMachineDowntimes()
          this.removeDialog = false
          this.loading = false
        })
        .catch((err) => {
          window.scrollTo(0, 0)
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async cancelClosing() {
      this.cancelClosingLoading = true

      const serviceOrder = {
        Id: this.currentServiceOrder.id,
        CloseServiceOrderDateTime: null,
        EmailForEvaluation: null,
        RatingServiceCompleted: null,
        RatingServiceTime: null,
        isExecutingSigned: false,
        ExecutingUserId: null,
      }

      await this.apiService
        .post('serviceOrder/closeServiceOrder', serviceOrder)
        .then(() => {
          this.$router.go()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.cancelClosingLoading = false
    },

    async remove() {
      this.loading = true

      const serviceOrderId = this.currentServiceOrder.id

      const user = JSON.parse(localStorage.getItem('user'))
      const model = {
        serviceOrderId: serviceOrderId,
        archivedByuserId: user.id,
      }

      await this.apiService
        .delete(`serviceOrder/delete`, model)
        .then((response) => {
          if (response.statusCode == 200) {
            this.$toast.success(response.message)
            this.$router.push('/serviceOrders')
          }
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.loading = false
      this.deleteDialog = false
    },

    setRequestNowDate() {
      this.requestDateTime = !this.requestDateTime
        ? new Date()
        : this.requestDateTime
    },

    setAttendNowDate() {
      this.attendDateTime = !this.attendDateTime
        ? new Date()
        : this.attendDateTime
    },

    exitAuthorization() {
      sessionStorage.setItem(
        'serviceOrder',
        JSON.stringify(this.currentServiceOrder)
      )
      const routeData = router.resolve({
        path: '/exitAuthorization',
      })
      window.open(routeData.href, '_blank')
    },

    formatDateTime(date) {
      if (!date) return
      return Utils.dateTime(date)
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    parseDate(date) {
      if (!date) return null

      const dateTimeSplit = date.split(' ')

      const [day, month, year] = dateTimeSplit[0].split('/')
      const time = dateTimeSplit[1]

      if (time) {
        return `${year}-${month.padStart(2, '0')}-${day.padStart(
          2,
          '0'
        )} ${time}:00`
      }

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatInitialDate(dateInitial) {
      const date = new Date(dateInitial),
        day = date.getDate().toString(),
        dayF = day.length == 1 ? '0' + day : day,
        month = (date.getMonth() + 1).toString(),
        monthF = month.length == 1 ? '0' + month : month,
        yearF = date.getFullYear()
      return `${dayF}-${monthF}-${yearF}`
    },

    async querySelectionsEquipment(value) {
      this.equipmentLoading = true

      setTimeout(() => {
        this.equipmentsFiltered = this.equipments.filter((e) => {
          return e.identification.indexOf(value) > -1
        })

        this.equipmentLoading = false
        if (this.equipmentId) {
          this.getEquipmentById()
        }
      }, 500)
    },

    async querySelectionsEquipments(value) {
      this.equipmentLoading = true

      setTimeout(() => {
        this.equipmentsFiltered = this.equipments.filter((e) => {
          if (e.propertyCode != null) {
            return e.propertyCode.indexOf(value) > -1
          }
        })
        this.equipmentLoading = false
        if (this.equipmentId) {
          this.getEquipmentById()
        }
      }, 500)
    },

    async getEquipmentById() {
      if (this.equipmentId) {
        if (this.equipmentSelected) {
          await this.apiService
            .get(`equipment/${this.institutionId}/${this.equipmentId}`)
            .then((response) => {
              this.equipmentSelected = response.content
              this.unidadeId = response.content.unidadeId
              if (response.content.costCenterId != null) {
                this.costCenterId = response.content.costCenterId
                this.costCenterName = response.content.costCenter.name
              }
            })
        }
      }
      await this.getDepartment()
      await this.getChecklistTemplate()
      this.getCostCenter()
    },

    async getDepartment() {
      this.departmentId = this.equipmentSelected.departmentId
      await this.apiService
        .get(`department/${this.departmentId}`)
        .then((response) => {
          this.departmentName = response.content.name
        })
    },

    getCostCenter() {
      if (this.costCenterId == null) {
        const costCenter = this.costCenters.find(
          (x) => x.departmentId === this.equipmentSelected.departmentId
        )
        if (costCenter) {
          this.costCenterId = costCenter.id
          this.costCenterName = costCenter.name
        }
      }
    },
  },

  watch: {
    unidadeId() {
      if (this.unidadeId) {
        this.getCostCenters()
      } else {
        this.costCenters = []
      }
    },

    currentServiceOrder: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },

    requestDateTime: {
      deep: true,
      handler() {
        this.changedData = true
        this.requestDateTimeError = false
      },
    },

    attendDateTime: {
      deep: true,
      handler() {
        this.changedData = true
        this.attendDateTimeError = false
      },
    },

    searchEquipment(value) {
      value &&
        value !== this.equipmentId &&
        this.querySelectionsEquipment(value)
    },

    searchEquipmentPropertyCode(value) {
      value &&
        value !== this.equipmentId &&
        this.querySelectionsEquipments(value)
    },
  },
}
